/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { lupDependencies } from './dependenciesLup.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { subtractDependencies } from './dependenciesSubtract.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { unaryMinusDependencies } from './dependenciesUnaryMinus.generated';
import { createDet } from '../../factoriesAny.js';
export var detDependencies = {
  lupDependencies: lupDependencies,
  matrixDependencies: matrixDependencies,
  multiplyDependencies: multiplyDependencies,
  subtractDependencies: subtractDependencies,
  typedDependencies: typedDependencies,
  unaryMinusDependencies: unaryMinusDependencies,
  createDet: createDet
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesDet.generated.js
// module id = 494
// module chunks = 0